export default __webpack_public_path__ + "static/media/tiger.4e884d2f.png";